import Alpine from 'alpinejs';
import Swal from 'sweetalert2';
import mask from '@alpinejs/mask';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import * as FilePond from 'filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import Iodine from '@caneara/iodine';
import Datepicker from 'flowbite-datepicker/Datepicker';
import datepickerCs from 'flowbite-datepicker/locales/cs';

document.addEventListener("DOMContentLoaded", function(event) {

FilePond.registerPlugin(FilePondPluginFileValidateSize);
FilePond.registerPlugin(FilePondPluginFileValidateType);
FilePond.registerPlugin(FilePondPluginImagePreview);

const url = new URL(window.location.href);
const lang = url.searchParams.get('language');
let env;
if (!window.location.hostname.includes('lib.cas.cz')) {
    env = 'development'
} else if (window.location.href.includes('zkusebni-registrace')) {
    env = 'staging';
} else {
    env = 'production';
}

let grecaptchaKey;
if (document.getElementById('grecaptcha')) {
    let grecaptchaScriptSrc = document.getElementById('grecaptcha').src;
    grecaptchaKey = new URL(grecaptchaScriptSrc).searchParams.get('render');
}

const telephoneInput = document.getElementById('telefon');

/**
 * Formats czech phone number for better reading experience
 * 
 * @param {string} tel - The CZ phone number to format e.g 760789123 or +420760789123.
 * @returns {string} The formatted CZ phone number.
 */
function formatCzTel(tel) {
    // Remove any non-digit characters (except for the leading + if present)
    let cleaned = tel.startsWith('+') ? '+' : '';
    cleaned += tel.replace(/[^\d]/g, '');

    // Use a regular expression to format the number
    let match = cleaned.match(/(\+?\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/);
    let formatted = match[1];
    
    for (let i = 2; i <= 4; i++) {
        if (match[i]) {
            formatted += (formatted.length > 0 ? ' ' : '') + match[i];
        }
    }

    return formatted;
}

const intlTelInputUtilsScripts = {
    development: '/dist/intl-tel-input.utils.js',
    staging: '/zkusebni-registrace/public/dist/intl-tel-input.utils.js',
    production: '/registrace/public/dist/intl-tel-input.utils.js'
};
let phoneHandler;
if (telephoneInput) {
    // Render intlTelInput
    phoneHandler = intlTelInput(telephoneInput, {
        utilsScript: intlTelInputUtilsScripts[env],
        preferredCountries: ['cz', 'sk'],
        formatOnDisplay: true,
    });

    // intlTelInput automatically adds `.iti-mobile` into the DOM on mobile screens
    if (document.querySelector('.iti-mobile')) {
        // Disable custom intlTelInput country filter box on mobile screens
        document.getElementById('regform-country-searchbox').remove();
    } else {
        // Extending the intlTelInput instance for custom behavior and custom filter/search box on desktops
        Object.assign(phoneHandler, {
            searchMode: false,
            active: false,
            searchEl: document.getElementById('regform-country-searchbox'),
            searchInputEl: document.getElementById('regform-country-searchinput'),
            searchDebounce: function(func, wait) {
                let timeout;
                
                return function executedFunction(...args) {
                    const later = () => {
                        clearTimeout(timeout);
                        func(...args);
                    };
                    
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                };
            },
            searchDebounceTime: 500,
            dropdownListEl: document.querySelector('ul.iti__country-list'),
            dropdownBtnEl: document.querySelector('.iti__selected-flag'),
            setActive: function() {
                this.active = true;
            },
            setInactive: function() {
                this.active = false;
            },
            startSearchMode: function() {
                if (!this.searchMode) {
                    this.countryList.querySelectorAll('.iti__preferred, .iti__preferred + .iti__divider').forEach(function(element) {
                        element.classList.add('hidden');
                    });
                }
                this.searchMode = true;
            },
            endSearchMode: function() {
                if (this.searchMode) {
                    this.searchInputEl.value = '';
                    this.countryList.querySelectorAll('li').forEach(function(element) {
                        element.classList.remove('hidden');
                    });
                }
                this.searchMode = false;
            },
            closeDropdown: function() {
                this.setInactive();
                this.endSearchMode();
                if (!this.countryList.classList.contains('iti__hide')) {
                    this._closeDropdown();
                }
                telephoneInput.blur();
                telephoneInput.focus();
            },
            showDropdown: function() {
                this.setActive();

                if (this.countryList.classList.contains('iti__hide')) {
                    this._showDropdown();
                }

                this.searchInputEl.focus();

                document.documentElement.removeEventListener('click', this._handleClickOffToClose);
                this.countryList.removeEventListener('click', this._handleClickCountryList.bind(this));
                document.removeEventListener('keydown', this._handleKeydownOnDropdown);

                document.addEventListener('keydown', this.handleFlagsContainerKeydown.bind(this));
                this.countryList.addEventListener('click', this.handleClickCountryList.bind(this));
            },
            handleClickCountryList: function(ev) {
                const listItem = this._getClosestListItem(ev.target);
                if (listItem) {
                    this._selectListItem(listItem);
                    this.closeDropdown();
                }
            },
            searchForCountry: function() {
                const query = this.searchInputEl.value.toLowerCase();
        
                if (this.searchMode && query.trim() === '') {
                    this.endSearchMode();
                } else {
                    this.startSearchMode();
                    this.countries.forEach(function(country) {
                        const countryLiEl = document.getElementById('iti-0__item-' + country.iso2),
                            countryName = country.name.toLowerCase(),
                            countryIso2 = '+' + country.iso2,
                            countryDialCode = '+' + country.dialCode;

                        if (
                            !countryName.includes(query) && 
                            !countryIso2.includes(query) && 
                            !countryDialCode.includes(query)
                        ) {
                            countryLiEl.classList.add('hidden');
                        } else {
                            countryLiEl.classList.remove('hidden');
                        }
                    });
                }
            },
            handleFlagsContainerKeydown: function(e) {
                if (
                    e.key === 'ArrowUp' ||
                    e.key === 'Up' ||
                    e.key === 'ArrowDown' ||
                    e.key === 'Down'
                ) {
                    this._handleUpDownKey(e.key);
                }
        
                else if (e.key === 'Enter') {
                    this._handleEnterKey();
                    this.closeDropdown();
                }
        
                else if (e.key === 'Escape' || e.key === 'Tab' ) {
                    this.closeDropdown();
                }
            },
            afterRender: function() {
                const phoneLiSearchEl = document.createElement('li');
                const phoneLiDividerEl = document.createElement('li');
        
                phoneLiDividerEl.classList.add('iti__divider');
                phoneLiDividerEl.setAttribute('role', 'separator');
                phoneLiDividerEl.setAttribute('aria-disabled', 'true');
                phoneLiSearchEl.id = this.dropdownListEl.id + '-search';
                phoneLiSearchEl.disabled = true;
                phoneLiSearchEl.prepend(this.searchEl);
        
                this.dropdownListEl.prepend(phoneLiDividerEl);
                this.dropdownListEl.prepend(phoneLiSearchEl);
        
                this.dropdownBtnEl.addEventListener('click', () => {
                    if (!this.active) {
                        this.showDropdown();
                    } else {
                        this.closeDropdown();
                    }
                });
        
                this.searchInputEl.addEventListener(
                    'keyup',
                    this.searchDebounce(this.searchForCountry.bind(this), this.searchDebounceTime)
                );
            },
        });

        // Apply custom changes to the intlTelInput instance
        phoneHandler.afterRender();
    }
}

const registerForm = document.getElementById('reg-form');

const regFormValidator = new Iodine();

// Custom validation rule for the `dd.mm.yyyy` date format
regFormValidator.rule('dateOfBirthFormat', (value) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.\d{4}$/;
    return regex.test(value);
});

// Custom validation rule to ensure the date is not in the future
regFormValidator.rule('dateNotInFuture', (value) => {
    const dateParts = value.split('.');
    const inputDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return inputDate <= today;
});

// Custom validation rule to ensure that the date exist
regFormValidator.rule('dateMustExist', (value) => {
    const dateParts = value.split('.');
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const year = parseInt(dateParts[2], 10);
    const date = new Date(year, month, day);
    return (!isNaN(date.getTime()) && date.getDate() === day && date.getMonth() === month && date.getFullYear() === year);
});

// Custom validation rule for the `XXXXX` ZIP code (PSC) format
regFormValidator.rule('zipcodeFormat', (value) => {
    const regex = /^\d{5}$/;
    return regex.test(value);
});

// Custom validation rule for czech ZIP code (PSC) which can only begin with 1/2/3/...7
regFormValidator.rule('zipcodeFormatCz', (value) => {
    const notAllowedFirstNums = [0, 8, 9]; 
    return notAllowedFirstNums.indexOf(parseInt(value[0])) === -1;
});

// Custom validation rule for the phone number format
regFormValidator.rule('phoneFormat', (value) => {
    // Using intlTelInput's phone number validation process
    return phoneHandler.isValidNumber();
});

const regformdata = function() {
    return {
        fields: {
            jmeno: {
                value: null, error: null,
                rules: ['required', 'maxLength:60'],
                errors: {
                    'required': 'regform_field_required',
                    'maxLength:60': 'regform_max_length_exceeded'
                }
            },
            prijmeni: {
                value: null, error: null,
                rules: ['required', 'maxLength:60'],
                errors: {
                    'required': 'regform_field_required',
                    'maxLength:60': 'regform_max_length_exceeded'
                }
            },
            email: {
                value: null, error: null,
                rules: ['required', 'email', 'maxLength:90'],
                errors: {
                    'required': 'regform_field_required',
                    'email': 'regform_invalid_email',
                    'maxLength:90': 'regform_max_length_exceeded'
                }
            },
            dob: {
                value: null, error: null,
                rules: ['required', 'dateOfBirthFormat', 'maxLength:10', 'dateMustExist', 'dateNotInFuture'],
                errors: {
                    'required': 'regform_field_required',
                    'dateOfBirthFormat': 'regform_invalid_date_format',
                    'maxLength:10': 'regform_max_length_exceeded',
                    'dateNotInFuture': 'regform_date_is_in_future',
                    'dateMustExist': 'regform_date_nonexisting'
                }
            },
            ulice: {
                value: null, error: null,
                rules: ['required', 'maxLength:60'],
                errors: {
                    'required': 'regform_field_required',
                    'maxLength:60': 'regform_max_length_exceeded'
                }
            },
            mesto: {
                value: null, error: null,
                rules: ['required', 'maxLength:60'],
                errors: {
                    'required': 'regform_field_required',
                    'maxLength:60': 'regform_max_length_exceeded'
                }
            },
            psc: {
                value: null, error: null,
                rules: ['required', 'maxLength:5', 'zipcodeFormat', 'zipcodeFormatCz'],
                errors: {
                    'required': 'regform_field_required',
                    'zipcodeFormat': 'regform_invalid_zipcode_format',
                    'zipcodeFormatCz': 'regform_invalid_zipcode_format_cz',
                    'maxLength:5': 'regform_max_length_exceeded',
                }
            },
            telefon: {
                value: null, error: null,
                rules: ['required', 'maxLength:20', 'phoneFormat'],
                errors: {
                    'required': 'regform_field_required',
                    'phoneFormat': 'regform_invalid_phone',
                    'maxLength:20': 'regform_max_length_exceeded',
                }
            },
            priloha1: {
                error: null
            },
            priloha2: {
                error: null
            },
            priloha3: {
                error: null
            },
        },
        firstInvalidField: null,
        isSubmitting: false,
        isFormInvalid: true,
        validateField(field, event) {
            const value = event ? event.target.value : field.value;
            let res = regFormValidator.assert(value, field.rules, field.errors);
            field.error = res.valid ? null : res.error;
            this.isFormValid();
        },
        isFormValid() {
            for (const fieldName of Object.keys(this.fields)) {
                const fieldVal = this.fields[fieldName];

                if (fieldVal.error !== null && fieldVal.error !== undefined) {
                    this.isFormInvalid = true;
                    this.firstInvalidField = fieldName;
                    return false;
                }
            }

            this.firstInvalidField = null;

            return true;
        },
        getTranslation(key) {
            return window.translations[key] || key;
        },
        submitBtnDisabled() {
            // This method can be used to automatically disable/enable the submit button like this:
            // <button type="submit" x-bind:disabled="submitBtnDisabled">Submit</button>
            return this.isFormInvalid;
        },
        submit(e) {
            e.preventDefault();

            let ok = this.isFormValid();

            if (ok) {
                let self = this;

                if (typeof phoneHandler !== 'undefined') {
                    if (phoneHandler.isValidNumber()) {
                        telephoneInput.value = phoneHandler.getNumber();
                    }
                }

                const formattedEmail = document.getElementById('email').value;
                const formattedTel = phoneHandler.selectedCountryData.iso2 === 'cz' ? formatCzTel(document.getElementById('telefon').value) : document.getElementById('telefon').value;
        
                Swal.fire({
                    titleText: messages.verifyTitle,
                    html:   `<p>${messages.verifyDescription}</p><br>
                            <ul>
                                <li>${messages.email}: <strong>${formattedEmail}</strong></li>
                                <li>${messages.telefon}: <strong>${formattedTel}</strong></li>
                            </ul>`,
                    icon: 'info',
                    footer: messages.bottomText,
                    showCancelButton: true,
                    cancelButtonText: messages.verifyCancel,
                    confirmButtonText: messages.verifyAccept,
                    customClass: {
                        confirmButton: 'bg-c-primary text-c-secondary font-semibold hover:bg-c-tertiary rounded',
                        cancelButton: 'bg-c-secondary text-c-primary font-semibold hover:bg-c-secondary hover:text-c-tertiary rounded',
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        grecaptcha.ready(function() {
                            grecaptcha.execute(grecaptchaKey, {action: 'reg_form_submit'})
                                .then(function(token) {
                                    let recaptchaInput = document.createElement('input');
                                    recaptchaInput.setAttribute('type', 'hidden');
                                    recaptchaInput.setAttribute('name', 'g-recaptcha-response');
                                    recaptchaInput.setAttribute('value', token);
                                    registerForm.prepend(recaptchaInput);
                                    self.isSubmitting = true;
                                    registerForm.submit();
                                });
                        });
                    }
                });
            } else {
                // These lines won't work if the submitBtnDisabled() method was used to automatically disable/enable the submit button
                const invalidFieldEl = document.querySelector('label[for="' + this.firstInvalidField + '"]');
                invalidFieldEl.scrollIntoView({
                    behavior: 'smooth',
                });
            }

            return ok;
        },
    };
};

const dobInputEl = document.getElementById('dob');
const dobBtnEl = document.getElementById('dob-btn');
if (dobInputEl) {
    Object.assign(Datepicker.locales, datepickerCs);

    const dobDatepicker = new Datepicker(dobInputEl, {
        autohide: false,
        clearBtn: true,
        format: 'dd.mm.yyyy',
        language: lang == null ? 'cs' : lang,
        maxDate: 'today',
        orientation: 'bottom left',
        showOnClick: false,
        showOnFocus: false,
        todayBtn: true,
        todayHighlight: true,
    });

    Object.assign(dobDatepicker, {
        customActive: false,
        inputEl: dobInputEl,
        triggerBtnEl: dobBtnEl,
        triggerBtnArrowEl: dobBtnEl.querySelector('.iti__arrow'),
        handleDocumentClick: function(ev) {
            ev.preventDefault();
            ev.stopPropagation();

            let targetElement = ev.target;

            do {
                if (targetElement === this.picker.controls.clearBtn || (targetElement.classList && targetElement.classList.contains('day') && !targetElement.classList.contains('disabled'))) {
                    break;
                }
                if (targetElement === this.dobBtnEl || targetElement === this.picker.element || (targetElement.classList && targetElement.classList.contains('datepicker-cell')  & !targetElement.classList.contains('day'))) {
                    return;
                }
                targetElement = targetElement.parentNode;
            } while (targetElement);

            this.customHide();
        },
        afterDatePicked: function(ev) {
            setTimeout(() => {
                this.inputEl.focus();
                this.inputEl.blur();
            }, 600);
        },
        customShow: function() {
            this.show();
            this.customActive = true;
            this.triggerBtnArrowEl.classList.add('iti__arrow--up');
            this.handleDocumentClickBound = this.handleDocumentClick.bind(this);
            document.addEventListener('click', this.handleDocumentClickBound);
        },
        customHide: function() {
            this.hide();
            this.customActive = false;
            this.triggerBtnArrowEl.classList.remove('iti__arrow--up');
            document.removeEventListener('click', this.handleDocumentClickBound);
        },
        afterRender: function() {
            this.picker.element.classList.remove('top-0', 'left-0');

            this.triggerBtnEl.addEventListener('click', (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                if (this.customActive) {
                    this.customHide();
                } else {
                    this.customShow();
                }
            });

            this.inputEl.addEventListener('changeDate', this.afterDatePicked.bind(this));
        }
    });

    dobDatepicker.afterRender();
}

Alpine.plugin(mask);
window.Alpine = Alpine;
Alpine.data('regformdata', regformdata);
Alpine.start();

document.querySelectorAll('input[type="file"]').forEach((inputElement) => {
    const regformObjData = document.querySelector('[x-data="regformdata()"]')._x_dataStack[0];
    const inputName = inputElement.id;

    const fileInput = FilePond.create(inputElement, {
        credits: false,
        acceptedFileTypes: [
            'image/png',
            'image/gif',
            'image/jpg',
            'image/jpeg',
            'application/pdf',
        ],
        allowImagePreview: true,
        maxFileSize: '10MB',
        storeAsFile: true,
        labelIdle: window.translations['filepond_label_idle'],
        labelMaxFileSizeExceeded: window.translations['regform_max_file_size_exceeded'],
        labelMaxFileSize: window.translations['regform_max_file_size'],
        labelFileTypeNotAllowed: window.translations['regform_invalid_file_type'],
        fileValidateTypeLabelExpectedTypes: window.translations['regform_allowed_file_types'],
    });
    
    fileInput.on('addfile', (error, file) => {
        if (error) {
            regformObjData.fields[inputName].error = error.main;
        } else {
            regformObjData.fields[inputName].error = null;
        }
        regformObjData.isFormValid();
    });

    fileInput.on('removefile', (file, a) => {
        const inputIsRequired = inputElement.getAttribute('required');
        if (inputIsRequired) {
            regformObjData.fields[inputName].error = window.translations['regform_field_required']
        }
        regformObjData.isFormValid();
    });
});

});